import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

import { QuotationComponent } from '../../quotation/quotation.component';
import { QuotationPdfViewerComponent } from '../quotation-pdf/quotation-pdf-viewer/quotation-pdf-viewer.component';
import { MessageDialogComponent } from '../message-dialog/message-dialog.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { SendMailTicketObj } from '../../../shared/models/quotation-model/main/send-mail.model';
import { EventEmiterService } from '../../../shared/services/quotation/event-emiter.service';
import { QuotationService } from '../../../shared/services/quotation/quotation.service';
import { MatFormField, MatHint } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-send-request-dialog',
  templateUrl: './send-request-dialog.component.html',
  styleUrls: ['./send-request-dialog.component.scss'],
  standalone: true,
  imports: [
    MatFormField,
    MatHint,
    TranslateModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    FormsModule,
  ],
})
export class SendRequestDialogComponent implements OnInit {
  emails!: string;
  appToken!: string;
  newTicketObj!: SendMailTicketObj;
  error: boolean = false;
  emailPattern = /^\S+@\S+\.\S+$/;

  constructor(
    public dialogRef: MatDialogRef<QuotationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { ticketObj: SendMailTicketObj },
    public dialog: MatDialog,
    private quotationService: QuotationService,
    public router: Router,
    private translate: TranslateService,
    public loader: EventEmiterService,
  ) {}

  sendRequest() {
    var niceEmails = '';
    var separator = ';';
    this.error = false;
    const array = this.emails.split(separator);
    array.forEach((email) => {
      if (!email.trim().match(this.emailPattern)) {
        this.error = true;
      }
      niceEmails += email.trim() + separator;
    });
    niceEmails = niceEmails.slice(0, -1);
    if (!this.error) {
      this.data.ticketObj.externalEmail = niceEmails;
      this.loader.isLoadingPage(true);
      this.dialogRef.close();
      const dialogRef = this.dialog.open(QuotationPdfViewerComponent, {
        width: '750px',
        data: {
          ticketId: this.data.ticketObj.ticketId,
          hasAttachDocument: true,
          action: 'Finalizar',
        },
        panelClass: 'dialog-container-custom',
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe(() => {
        this.loader.isLoadingPage(true);
        this.quotationService.sendMailDynamic(this.data.ticketObj).subscribe(() => {
          this.loader.isLoadingPage(false);
          const toClose = this.dialog.open(MessageDialogComponent, {
            width: '350px',
            data: this.translate.instant('quotation.fieldNames.emailSentSuccessfull'),
            panelClass: 'dialog-container-custom',
          });
          toClose.afterClosed().subscribe(() => {
            this.router.navigate(['/quotation']);
          });
        });
      });
    }
  }
  ngOnInit() {}
}
